/* eslint-disable import/no-anonymous-default-export */
import {
  GET_TERM_RECORDS,
  GET_TERM_RECORDS_SUCCESS,
  GET_TERM_RECORDS_ERROR,
  UPDATE_TERM_RECORDS,
  REFRESH_TERM_RECORDS,
  UPDATE_SEARCH_RECORDS,
} from "../actions";

const INIT_STATE = {
  loading: false,
  error: "",
  selectedTermRecords: [],
  searchText: "",
 recordTermList: {
    records: [],
    searchText:"",
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      startIndex: 1,
      totalItemCount: 0,
      totalPages: 0,
    },
   
    responseTime: null
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TERM_RECORDS:
      return {
        ...state,
        loading: true,
        error: "",
        recordTermList: null,
        vocabularyId: action.payload.vocabularyId,
      };
    case GET_TERM_RECORDS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        recordTermList: action.payload,
      };
    case GET_TERM_RECORDS_ERROR:
      let recordTermList = { ...state.recordTermList, records: [] };
      recordTermList.pagination = {
        ...recordTermList.pagination,
        totalItemCount: 0,
        totalPages: 0,
      };
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        recordTermList: recordTermList,
      };
    case UPDATE_TERM_RECORDS:
       return { ...state, selectedTermRecords: action.payload.newRecordList };
    case UPDATE_SEARCH_RECORDS:
      return { ...state, searchText: action.payload.searchText };

    case REFRESH_TERM_RECORDS:
      {
         return { ...state, loading : false };
      }
    default:
      return { ...state };
  }
};
